var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeysetupfour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.9994C1 10.925 1.53775 8.88606 2.56077 7.08147C3.5838 5.27687 5.05716 3.7683 6.83709 2.70295C8.61702 1.63759 10.6427 1.05184 12.7166 1.00286C14.7904 0.953873 16.8415 1.44332 18.6697 2.42345",
    stroke: "#7647EE",
    strokeWidth: 0.888883
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 12.9993C24.9999 15.6144 24.1457 18.1579 22.5671 20.2428C20.9886 22.3277 18.7722 23.8399 16.2552 24.5492C13.7381 25.2586 11.0583 25.1264 8.62334 24.1726C6.18839 23.2188 4.13167 21.4957 2.76611 19.2655",
    stroke: "#7647EE",
    strokeWidth: 0.888883
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.9993,
    r: 10.2856,
    fill: "#1E016F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0629 17.7136V15.7936H9.24921V14.6416L13.8297 8.11369H15.5029V14.5319H16.8469V15.7936H15.5029V17.7136H14.0629ZM10.8263 14.5319H14.1452V9.71825L10.8263 14.5319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeysetupfour);
export default __webpack_public_path__ + "static/media/keysetupfour.37576c337702854ac581146384177cb3.svg";
export { ForwardRef as ReactComponent };